export default [{name:"Afganistan",code:"af"},
{name:"Albania",code:"al"},
{name:"Algieria",code:"dz"},
{name:"Andora",code:"ad"},
{name:"Angola",code:"ao"},
{name:"Anguilla",code:"ai"},
{name:"Antarktyka",code:"aq"},
{name:"Antigua i Barbuda",code:"ag"},
{name:"Arabia Saudyjska",code:"sa"},
{name:"Argentyna",code:"ar"},
{name:"Armenia",code:"am"},
{name:"Aruba",code:"aw"},
{name:"Australia",code:"au"},
{name:"Austria",code:"at"},
{name:"Azerbejdżan",code:"az"},
{name:"Bahamy",code:"bs"},
{name:"Bahrajn",code:"bh"},
{name:"Bangladesz",code:"bd"},
{name:"Barbados",code:"bb"},
{name:"Belgia",code:"be"},
{name:"Belize",code:"bz"},
{name:"Benin",code:"bj"},
{name:"Bermudy",code:"bm"},
{name:"Bhutan",code:"bt"},
{name:"Białoruś",code:"by"},
{name:"Boliwia",code:"bo"},
{name:"Bonaire, Sint Eustatius i Saba",code:"bq"},
{name:"Bośnia i Hercegowina",code:"ba"},
{name:"Botswana",code:"bw"},
{name:"Brazylia",code:"br"},
{name:"Brunei",code:"bn"},
{name:"Brytyjskie Terytorium Oceanu Indyjskiego",code:"io"},
{name:"Brytyjskie Wyspy Dziewicze",code:"vg"},
{name:"Bułgaria",code:"bg"},
{name:"Burkina Faso",code:"bf"},
{name:"Burundi",code:"bi"},
{name:"Chile",code:"cl"},
{name:"Chiny",code:"cn"},
{name:"Chorwacja",code:"hr"},
{name:"Curaçao",code:"cw"},
{name:"Cypr",code:"cy"},
{name:"Czad",code:"td"},
{name:"Czarnogóra",code:"me"},
{name:"Czechy",code:"cz"},
{name:"Dalekie Wyspy Mniejsze Stanów Zjednoczonych",code:"um"},
{name:"Dania",code:"dk"},
{name:"Demokratyczna Republika Konga",code:"cd"},
{name:"Dominika",code:"dm"},
{name:"Dominikana",code:"do"},
{name:"Dżibuti",code:"dj"},
{name:"Egipt",code:"eg"},
{name:"Ekwador",code:"ec"},
{name:"Erytrea",code:"er"},
{name:"Estonia",code:"ee"},
{name:"Eswatini",code:"sz"},
{name:"Etiopia",code:"et"},
{name:"Falklandy",code:"fk"},
{name:"Fidżi",code:"fj"},
{name:"Filipiny",code:"ph"},
{name:"Finlandia",code:"fi"},
{name:"Francja",code:"fr"},
{name:"Francuskie Terytoria Południowe i Antarktyczne",code:"tf"},
{name:"Gabon",code:"ga"},
{name:"Gambia",code:"gm"},
{name:"Georgia Południowa i Sandwich Południowy",code:"gs"},
{name:"Ghana",code:"gh"},
{name:"Gibraltar",code:"gi"},
{name:"Grecja",code:"gr"},
{name:"Grenada",code:"gd"},
{name:"Grenlandia",code:"gl"},
{name:"Gruzja",code:"ge"},
{name:"Guam",code:"gu"},
{name:"Guernsey",code:"gg"},
{name:"Gujana Francuska",code:"gf"},
{name:"Gujana",code:"gy"},
{name:"Gwadelupa",code:"gp"},
{name:"Gwatemala",code:"gt"},
{name:"Gwinea Bissau",code:"gw"},
{name:"Gwinea Równikowa",code:"gq"},
{name:"Gwinea",code:"gn"},
{name:"Haiti",code:"ht"},
{name:"Hiszpania",code:"es"},
{name:"Holandia",code:"nl"},
{name:"Honduras",code:"hn"},
{name:"Hongkong",code:"hk"},
{name:"Indie",code:"in"},
{name:"Indonezja",code:"id"},
{name:"Irak",code:"iq"},
{name:"Iran",code:"ir"},
{name:"Irlandia",code:"ie"},
{name:"Islandia",code:"is"},
{name:"Izrael",code:"il"},
{name:"Jamajka",code:"jm"},
{name:"Japonia",code:"jp"},
{name:"Jemen",code:"ye"},
{name:"Jersey",code:"je"},
{name:"Jordania",code:"jo"},
{name:"Kajmany",code:"ky"},
{name:"Kambodża",code:"kh"},
{name:"Kamerun",code:"cm"},
{name:"Kanada",code:"ca"},
{name:"Katar",code:"qa"},
{name:"Kazachstan",code:"kz"},
{name:"Kenia",code:"ke"},
{name:"Kirgistan",code:"kg"},
{name:"Kiribati",code:"ki"},
{name:"Kolumbia",code:"co"},
{name:"Komory",code:"km"},
{name:"Kongo",code:"cg"},
{name:"Korea Południowa",code:"kr"},
{name:"Korea Północna",code:"kp"},
{name:"Kostaryka",code:"cr"},
{name:"Kuba",code:"cu"},
{name:"Kuwejt",code:"kw"},
{name:"Laos",code:"la"},
{name:"Lesotho",code:"ls"},
{name:"Liban",code:"lb"},
{name:"Liberia",code:"lr"},
{name:"Libia",code:"ly"},
{name:"Liechtenstein",code:"li"},
{name:"Litwa",code:"lt"},
{name:"Luksemburg",code:"lu"},
{name:"Łotwa",code:"lv"},
{name:"Macedonia Północna",code:"mk"},
{name:"Madagaskar",code:"mg"},
{name:"Majotta",code:"yt"},
{name:"Makau",code:"mo"},
{name:"Malawi",code:"mw"},
{name:"Malediwy",code:"mv"},
{name:"Malezja",code:"my"},
{name:"Mali",code:"ml"},
{name:"Malta",code:"mt"},
{name:"Mariany Północne",code:"mp"},
{name:"Maroko",code:"ma"},
{name:"Martynika",code:"mq"},
{name:"Mauretania",code:"mr"},
{name:"Mauritius",code:"mu"},
{name:"Meksyk",code:"mx"},
{name:"Mikronezja",code:"fm"},
{name:"Mjanma",code:"mm"},
{name:"Mołdawia",code:"md"},
{name:"Monako",code:"mc"},
{name:"Mongolia",code:"mn"},
{name:"Montserrat",code:"ms"},
{name:"Mozambik",code:"mz"},
{name:"Namibia",code:"na"},
{name:"Nauru",code:"nr"},
{name:"Nepal",code:"np"},
{name:"Niemcy",code:"de"},
{name:"Niger",code:"ne"},
{name:"Nigeria",code:"ng"},
{name:"Nikaragua",code:"ni"},
{name:"Niue",code:"nu"},
{name:"Norfolk",code:"nf"},
{name:"Norwegia",code:"no"},
{name:"Nowa Kaledonia",code:"nc"},
{name:"Nowa Zelandia",code:"nz"},
{name:"Oman",code:"om"},
{name:"Pakistan",code:"pk"},
{name:"Palau",code:"pw"},
{name:"Palestyna",code:"ps"},
{name:"Panama",code:"pa"},
{name:"Papua-Nowa Gwinea",code:"pg"},
{name:"Paragwaj",code:"py"},
{name:"Peru",code:"pe"},
{name:"Pitcairn",code:"pn"},
{name:"Polinezja Francuska",code:"pf"},
{name:"Polska",code:"pl"},
{name:"Portoryko",code:"pr"},
{name:"Portugalia",code:"pt"},
{name:"Południowa Afryka",code:"za"},
{name:"Republika Środkowoafrykańska",code:"cf"},
{name:"Republika Zielonego Przylądka",code:"cv"},
{name:"Reunion",code:"re"},
{name:"Rosja",code:"ru"},
{name:"Rumunia",code:"ro"},
{name:"Rwanda",code:"rw"},
{name:"Sahara Zachodnia",code:"eh"},
{name:"Saint Kitts i Nevis",code:"kn"},
{name:"Saint Lucia",code:"lc"},
{name:"Saint Vincent i Grenadyny",code:"vc"},
{name:"Saint-Barthélemy",code:"bl"},
{name:"Saint-Martin",code:"mf"},
{name:"Saint-Pierre i Miquelon",code:"pm"},
{name:"Salwador",code:"sv"},
{name:"Samoa Amerykańskie",code:"as"},
{name:"Samoa",code:"ws"},
{name:"San Marino",code:"sm"},
{name:"Senegal",code:"sn"},
{name:"Serbia",code:"rs"},
{name:"Seszele",code:"sc"},
{name:"Sierra Leone",code:"sl"},
{name:"Singapur",code:"sg"},
{name:"Sint Maarten",code:"sx"},
{name:"Słowacja",code:"sk"},
{name:"Słowenia",code:"si"},
{name:"Somalia",code:"so"},
{name:"Sri Lanka",code:"lk"},
{name:"Stany Zjednoczone",code:"us"},
{name:"Sudan",code:"sd"},
{name:"Sudan Południowy",code:"ss"},
{name:"Surinam",code:"sr"},
{name:"Svalbard i Jan Mayen",code:"sj"},
{name:"Syria",code:"sy"},
{name:"Szwajcaria",code:"ch"},
{name:"Szwecja",code:"se"},
{name:"Tadżykistan",code:"tj"},
{name:"Tajlandia",code:"th"},
{name:"Tajwan",code:"tw"},
{name:"Tanzania",code:"tz"},
{name:"Timor Wschodni",code:"tl"},
{name:"Togo",code:"tg"},
{name:"Tokelau",code:"tk"},
{name:"Tonga",code:"to"},
{name:"Trynidad i Tobago",code:"tt"},
{name:"Tunezja",code:"tn"},
{name:"Turcja",code:"tr"},
{name:"Turkmenistan",code:"tm"},
{name:"Turks i Caicos",code:"tc"},
{name:"Tuvalu",code:"tv"},
{name:"Uganda",code:"ug"},
{name:"Ukraina",code:"ua"},
{name:"Urugwaj",code:"uy"},
{name:"Uzbekistan",code:"uz"},
{name:"Vanuatu",code:"vu"},
{name:"Wallis i Futuna",code:"wf"},
{name:"Watykan",code:"va"},
{name:"Wenezuela",code:"ve"},
{name:"Węgry",code:"hu"},
{name:"Wielka Brytania",code:"gb"},
{name:"Wietnam",code:"vn"},
{name:"Włochy",code:"it"},
{name:"Wybrzeże Kości Słoniowej",code:"ci"},
{name:"Wyspa Bouveta",code:"bv"},
{name:"Wyspa Bożego Narodzenia",code:"cx"},
{name:"Wyspa Man",code:"im"},
{name:"Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",code:"sh"},
{name:"Wyspy Alandzkie",code:"ax"},
{name:"Wyspy Cooka",code:"ck"},
{name:"Wyspy Dziewicze Stanów Zjednoczonych",code:"vi"},
{name:"Wyspy Heard i McDonalda",code:"hm"},
{name:"Wyspy Kokosowe",code:"cc"},
{name:"Wyspy Marshalla",code:"mh"},
{name:"Wyspy Owcze",code:"fo"},
{name:"Wyspy Salomona",code:"sb"},
{name:"Wyspy Świętego Tomasza i Książęca",code:"st"},
{name:"Zambia",code:"zm"},
{name:"Zimbabwe",code:"zw"},
{name:"Zjednoczone Emiraty Arabskie",code:"ae"}]